var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 197,
    viewBox: "0 0 233 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.89 22.89V58.52H118.32C97.2301 58.52 80.08 75.6701 80.08 96.8501V105.2H71.1801L39.5 132.93C34.92 138.22 26.21 134.99 26.21 128.08V105.19H22.89C10.32 105.2 0 94.8801 0 82.2201V22.89C0 10.32 10.32 0 22.89 0H128.9C141.55 0 151.88 10.32 151.88 22.89H151.89Z",
    fill: "#0E9CFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.02 96.8201V149.41C98.02 160.6 107.17 169.75 118.36 169.75H169.58L197.66 194.34C201.73 199.02 209.46 196.17 209.46 190.07V169.75H212.36C223.55 169.75 232.7 160.6 232.7 149.41V96.8201C232.7 85.6301 223.55 76.4801 212.36 76.4801H118.36C107.17 76.4801 98.02 85.6401 98.02 96.8201Z",
    fill: "#0E9CFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/speech.ee7500636d787efa16c78f62b8aedb77.svg";
export { ForwardRef as ReactComponent };